import React from 'react';
import PropTypes from 'prop-types';

import theme from '../../themes/default';

import { ENTER } from '../../utils/keyCodes';
import { ChipWrapper, TextWrapper, CancelIconWrapper } from './Chip.style';

/* eslint-disable jsx-a11y/role-supports-aria-props */
const Chip = ({
  label,
  icon: Icon,
  isSelected,
  disabled,
  hasError,
  hasWarning,
  size,
  onClick,
  deleteAction,
  children,
}) => (
  <ChipWrapper
    size={size}
    tabIndex="0"
    role="button"
    isSelected={isSelected}
    disabled={disabled}
    hasError={hasError}
    hasWarning={hasWarning}
    onClick={onClick}
    deleteAction={deleteAction}
    onKeyDown={(e) => e.keyCode === ENTER && onClick(e)}
    aria-pressed={isSelected}
    aria-disabled={disabled}
    aria-invalid={hasError}
  >
    {Icon && (
      <Icon
        style={{
          fontSize: '20px',
          color: `${isSelected ? theme.color.purple : theme.color.grey6}`,
        }}
      />
    )}
    {label && <TextWrapper>{label}</TextWrapper>}
    {children}
    {deleteAction && (
      <CancelIconWrapper
        aria-label="chip-delete"
        tabIndex="0"
        role="button"
        onClick={(e) => {
          e.stopPropagation();
          deleteAction(e);
        }}
        onKeyDown={(e) => e.keyCode === ENTER && deleteAction(e)}
      />
    )}
  </ChipWrapper>
);

Chip.defaultProps = {
  label: null,
  size: 'small',
  isSelected: false,
  disabled: false,
  hasError: false,
  hasWarning: false,
  deleteAction: undefined,
  onClick: undefined,
  children: [],
  icon: null,
};

Chip.propTypes = {
  label: PropTypes.string,
  size: PropTypes.oneOf(['small', 'xs']),
  icon: PropTypes.elementType,
  isSelected: PropTypes.bool,
  disabled: PropTypes.bool,
  hasError: PropTypes.bool,
  hasWarning: PropTypes.bool,
  onClick: PropTypes.func,
  deleteAction: PropTypes.func,
  children: PropTypes.node,
};

export default React.memo(Chip);
